import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { findParentNode } from '../../../../utils/dom'
import { StoreProps } from '../../../services/stores/casting.store'
import CastingTooltipContentComponent from '../../plugins/casting/casting-tooltip-content.component'

type PositionningOptions = {
  parentOffset: number
  inputHeight: number
  tooltipHeight: number
  tooltipOffset: number
}

type Props = StoreProps & {
  linkedInput: React.ReactInstance
}

interface State {
  tooltipOffset: number
  arrowOffset: number
}

const defaults = { maxTooltipHeight: 250, arrowOffset: 0, arrowHeight: 10 }

export default class CastingTooltipContainerDesktopComponent extends React.Component<Props, State> {
  private tooltipRef = React.createRef<HTMLDivElement>()

  state: State = { tooltipOffset: 0, arrowOffset: 0 }

  componentDidMount () {
    const tooltipInfo = this.getTooltipInfo()
    this.defineTooltipPosition(tooltipInfo)
    const linkedInputElement = ReactDOM.findDOMNode(this.props.linkedInput) as HTMLElement
    linkedInputElement.focus()
  }

  private getElementHeight (element: HTMLElement) {
    return element.getBoundingClientRect().bottom - element.getBoundingClientRect().top
  }

  private getElementParentOffset (element: HTMLElement, parentClassName: string) {
    return element.getBoundingClientRect().top - findParentNode(element, parentClassName).getBoundingClientRect().top
  }

  private calcTooltipOffset (parentOffset: number, inputHeight: number, tooltipHeight: number) {
    // Tooltip should NOT have a negative offset
    return Math.max(0, parentOffset - (tooltipHeight / 2) + (inputHeight / 2))
  }

  private tooltipIsTooBig (tooltipHeight: number) {
    return tooltipHeight > defaults.maxTooltipHeight
  }

  private setTooltipAlignement (alignment: 'top' | 'centered', opts: PositionningOptions) {
    if (alignment === 'top') {
      this.setState({
        arrowOffset: opts.parentOffset + (opts.inputHeight / 2) - defaults.arrowHeight,
        tooltipOffset: 0,
      })
    } else {
      this.setState({
        arrowOffset: (opts.tooltipHeight / 2) - defaults.arrowHeight,
        tooltipOffset: opts.tooltipOffset,
      })
    }
  }

  private getTooltipInfo () {
    const linkedInputElement = ReactDOM.findDOMNode(this.props.linkedInput) as HTMLElement
    const parentOffset = this.getElementParentOffset(linkedInputElement, 'castingStep')
    const inputHeight = this.getElementHeight(linkedInputElement)
    const tooltipHeight = this.getElementHeight(this.tooltipRef.current)

    return {
      parentOffset,
      inputHeight,
      tooltipHeight,
      tooltipOffset: this.calcTooltipOffset(parentOffset, inputHeight, tooltipHeight)
    }
  }

  private defineTooltipPosition (opts: PositionningOptions) {
    if (!this.tooltipIsTooBig(opts.tooltipHeight)) {
      if (opts.tooltipOffset === 0) {
        this.setTooltipAlignement('top', opts)
      } else {
        this.setTooltipAlignement('centered', opts)
      }
    } else {
      this.setTooltipAlignement('top', opts)
    }
  }

  render () {
    const { store, data: { focusedInput } } = this.props
    const tooltipName = (['start-date', 'frequency', 'complex', 'offered-service', 'backoffice-appointment', 'backoffice-service-delivery', 'group-session'] as StoreProps['data']['focusedInput'][]).includes(focusedInput) ? null : store.getStepTitle(focusedInput)

    return <div className={ window.env === 'test' ? '' : 'stepTooltipAnim' }>
      <div className="stepTooltip" ref={ this.tooltipRef } style={{ transform: `translateY(${(this.state.tooltipOffset)}px)` }}>
        <div className="stepTooltip-arrow" style={{ top: `${this.state.arrowOffset}px` }}></div>
        <div id={ `js-test-tooltip-${focusedInput}` } className="stepTooltip-content">
          { tooltipName && <h3 className="stepTooltip-title txtS u-mbm">{ tooltipName }</h3> }
          <CastingTooltipContentComponent store={ store } data={ store.data } />
        </div>
      </div>
    </div>
  }
}